import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function FeaturesBar() {
  const stats = [
    { icon: 'ri-book-open-line', value: siteInfo.totalComics, label: '漫画作品' },
    { icon: 'ri-user-smile-line', value: siteInfo.totalUsers, label: '注册用户' },
    { icon: 'ri-eye-line', value: siteInfo.dailyActive, label: '日活跃' },
    { icon: 'ri-shield-check-line', value: siteInfo.established, label: '年成立' },
  ];

  return (
    <section className="py-10 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center text-white">
              <i className={`${stat.icon} text-2xl mb-2 block`}></i>
              <div className="text-2xl md:text-3xl font-bold whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                {stat.value}
              </div>
              <p className="text-sm text-white/70 mt-1 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}